import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50db9496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recovery-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recovery-form__title" }, " Восстановление пароля ", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recovery-form__text" }, " Email ", -1 /* HOISTED */))
const _hoisted_4 = { class: "recovery-form__help" }

import pInput from '../../common/pInput/pInput.vue'
import pButton from '../../common/pButton/pButton.vue'
import { Ref, ref } from 'vue'
import { useAuthPopup } from './../store/authPopup'
import api from "../api/api";
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecoveryForm',
  setup(__props) {

const authPopupStore = useAuthPopup()
const recoveryFormData: Ref<{email: string}> = ref({
  email: '',
})

function setEmail(event: Event) {
  recoveryFormData.value.email = (event.target as HTMLInputElement).value
}

async function sendRequest() {
  try {
    await api.recoveryPassword({
      email: recoveryFormData.value.email,
    })
    window.showNotification('На вашу почту отправлено сообщение для сброса пароля', 'success')
    authPopupStore.visible = false
  } catch (e: unknown) {
    if (e instanceof AxiosError && e.response?.data?.error) {
      window.showNotification(e.response.data.error, 'warning')
    } else {
      window.showNotification('Произошла ошибка при сбросе пароля', 'error')
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(pInput, {
      value: recoveryFormData.value.email,
      placeholder: 'Введите вашу почту',
      onInput: setEmail
    }, null, 8 /* PROPS */, ["value"]),
    _createVNode(pButton, {
      class: "recovery-form__submit",
      onClick: sendRequest
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Отправить ")
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("span", _hoisted_4, [
      _createTextVNode(" У вас нет учетной записи? "),
      _createElementVNode("span", {
        class: "recovery-form__sign",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(authPopupStore).openLoginForm && _unref(authPopupStore).openLoginForm(...args)))
      }, " Регистрация ")
    ])
  ]))
}
}

})